import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getAnalyticsMissionDataAction = createAsyncThunk(
    'no-of-missions-count',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/no-of-missions-count?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAnalyticsMissionDataSlice = createSlice({
    name: 'no-of-missions-count',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAnalyticsMissionDataAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAnalyticsMissionDataAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getAnalyticsMissionDataAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },
})


export const getAnalyticsMissionDataReducer = getAnalyticsMissionDataSlice.reducer